import * as React from "react";
import { useMemo, forwardRef } from "react";
import AsyncQueryInput from "views/components/searchbar/queryinput/AsyncQueryInput";
import useUserDateTime from "hooks/useUserDateTime";
import usePluginEntities from "hooks/usePluginEntities";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { isNoTimeRangeOverride } from "views/typeGuards/timeRange";
import { DEFAULT_TIMERANGE } from "views/Constants";
import SearchBarAutoCompletions from "./SearchBarAutocompletions";
const useCompleter = ({
  streams,
  timeRange,
  completerFactory,
  view
}) => {
  const { userTimezone } = useUserDateTime();
  const completers = usePluginEntities("views.completers");
  const { data: queryFields } = useFieldTypes(
    streams,
    isNoTimeRangeOverride(timeRange) ? DEFAULT_TIMERANGE : timeRange
  );
  const { data: allFields } = useFieldTypes([], DEFAULT_TIMERANGE);
  const fieldTypes = useMemo(() => {
    const queryFieldsByName = Object.fromEntries((queryFields != null ? queryFields : []).map((field) => [field.name, field]));
    const allFieldsByName = Object.fromEntries((allFields != null ? allFields : []).map((field) => [field.name, field]));
    return { all: allFieldsByName, query: queryFieldsByName };
  }, [allFields, queryFields]);
  return useMemo(
    () => completerFactory == null ? void 0 : completerFactory(completers != null ? completers : [], timeRange, streams, fieldTypes, userTimezone, view),
    [completerFactory, completers, timeRange, streams, fieldTypes, userTimezone, view]
  );
};
const defaultCompleterFactory = (...args) => new SearchBarAutoCompletions(...args);
const ViewsQueryInput = ({
  value,
  timeRange = void 0,
  streams = void 0,
  name,
  onChange,
  error = void 0,
  isValidating,
  disableExecution = void 0,
  validate,
  onExecute,
  commands = void 0,
  view = void 0,
  warning = void 0,
  placeholder = void 0,
  onBlur = void 0,
  inputId = void 0,
  completerFactory = defaultCompleterFactory
}, ref) => {
  const completer = useCompleter({ streams, timeRange, completerFactory, view });
  return /* @__PURE__ */ React.createElement(
    AsyncQueryInput,
    {
      value,
      onBlur,
      inputId,
      completer,
      ref,
      name,
      onChange,
      placeholder,
      error,
      isValidating,
      warning,
      disableExecution,
      validate,
      onExecute,
      commands
    }
  );
};
export default forwardRef(ViewsQueryInput);
